import _extends from "@babel/runtime/helpers/extends";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { Suspense } from "react";
import { GlobalContext } from "../Utils/contexts.js";
import { getTooltipStyles } from "./tooltipStyles.js";
var lazyWithPreload = function lazyWithPreload(factory) {
  var Component = /*#__PURE__*/React.lazy(factory);
  Component.preload = factory;
  return Component;
};
var ToolTipComponent = lazyWithPreload(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  var _result$default;
  var result;
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.next = 2;
        return import(/* webpackChunkName: "react-portal-tooltip" */
        "react-portal-tooltip");
      case 2:
        result = _context.sent;
        return _context.abrupt("return", (_result$default = result["default"]) !== null && _result$default !== void 0 && _result$default["default"] ? result["default"] : result);
      case 4:
      case "end":
        return _context.stop();
    }
  }, _callee);
})));
var Tooltip = /*#__PURE__*/function (_React$Component) {
  function Tooltip() {
    var _this;
    _this = _React$Component.apply(this, arguments) || this;
    _this.disabled = false;
    _this.mousePosition = {
      x: 0,
      y: 0
    };
    _this.state = {
      tooltipVisible: false
    };
    _this.showTooltip = function (e) {
      ToolTipComponent.preload();
      if (!e.target.disabled) {
        _this.mousePosition = {
          x: e.pageX,
          y: e.pageY
        };
        _this.timeoutId = setTimeout(function () {
          _this.setState({
            tooltipVisible: true
          }, function () {
            _this.forceUpdate();
            setTimeout(function () {
              return _this.props.followMouse && _this.updateTooltipPosition();
            });
          });
        }, 300);
      }
    };
    _this.onMouseMove = function (e) {
      if (_this.props.followMouse) {
        _this.mousePosition = {
          x: e.pageX,
          y: e.pageY
        };
        _this.updateTooltipPosition();
      }
    };
    _this.updateTooltipPosition = function () {
      var _this$mousePosition = _this.mousePosition,
        x = _this$mousePosition.x,
        y = _this$mousePosition.y;
      var element = document.querySelector(".ToolTipPortal > div");
      if (element) {
        var width = element.offsetWidth,
          height = element.offsetHeight;
        element.style.left = x - width / 2 + "px";
        element.style.top = y - height - 25 + "px";
      }
    };
    _this.hideTooltip = function () {
      clearTimeout(_this.timeoutId);
      _this.setState({
        tooltipVisible: false
      });
    };
    _this.wrappChildrenProp = function (propName, func) {
      var _ref2;
      return _ref2 = {}, _ref2[propName] = function (e) {
        var _this$props$children$, _this$props$children$2;
        func(e);
        (_this$props$children$ = (_this$props$children$2 = _this.props.children.props)[propName]) === null || _this$props$children$ === void 0 ? void 0 : _this$props$children$.call(_this$props$children$2, e);
      }, _ref2;
    };
    _this.wrapperProps = _extends({}, _this.wrappChildrenProp("onMouseEnter", _this.showTooltip), _this.wrappChildrenProp("onMouseLeave", _this.hideTooltip), _this.wrappChildrenProp("onClick", _this.hideTooltip), _this.wrappChildrenProp("onMouseMove", _this.onMouseMove));
    return _this;
  }
  _inheritsLoose(Tooltip, _React$Component);
  var _proto = Tooltip.prototype;
  _proto.componentDidUpdate = function componentDidUpdate() {
    this.disabled = window.richContentHideTooltips;
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.timeoutId);
  };
  _proto.render = function render() {
    var _this$props = this.props,
      children = _this$props.children,
      content = _this$props.content,
      isError = _this$props.isError,
      place = _this$props.place,
      tooltipOffset = _this$props.tooltipOffset,
      followMouse = _this$props.followMouse,
      hideArrow = _this$props.hideArrow,
      forceVisibility = _this$props.forceVisibility;
    var tooltipVisible = this.state.tooltipVisible;
    var isMobile = this.context.isMobile;
    var style = getTooltipStyles(isError, followMouse, tooltipOffset, place);
    var elementProps = forceVisibility || tooltipVisible ? _extends({}, this.wrapperProps, {
      "data-tooltipid": true
    }) : this.wrapperProps;
    var tooltipArrow = hideArrow ? null : "center";
    return isMobile || this.disabled || !content ? children : /* @__PURE__ */React.createElement(React.Fragment, null, /*#__PURE__*/React.cloneElement(React.Children.only(children), elementProps), forceVisibility || tooltipVisible ? /* @__PURE__ */React.createElement(Suspense, {
      fallback: null
    }, /* @__PURE__ */React.createElement(ToolTipComponent, {
      active: forceVisibility || tooltipVisible,
      parent: "[data-tooltipid=true]",
      position: place,
      arrow: tooltipArrow,
      style: style,
      tooltipTimeout: 10,
      group: "ricos"
    }, content)) : null);
  };
  return Tooltip;
}(React.Component);
Tooltip.defaultProps = {
  isError: false,
  place: "top",
  tooltipOffset: {
    x: 0,
    y: 0
  }
};
Tooltip.contextType = GlobalContext;
var Tooltip_default = Tooltip;
export { Tooltip_default as default };